module.exports = __webpack_public_path__ + "static/img/closeIcon.9c1051c.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/closeIcon.png
// module id = PTZP
// module chunks = 1